import React from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import NavBar from './NavBar';


const useStyles = makeStyles()((theme: Theme) => ({
    content: {
        marginLeft: 16,
        marginRight: 16,
        marginTop: 8,
        marginBottom: 8,
        [theme.breakpoints.down('lg')]: {
            marginLeft: 8,
            marginRight: 8,
        },
    }
}));

let NotAuthorizedLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { classes } = useStyles();

    return (
        <>
            <NavBar />
            <div className={classes.content}>
                {children}
            </div>
        </>
    )
}

export default NotAuthorizedLayout;